import React, { useEffect,useState,useRef } from "react";
import { Context,Hooks,Util,Request } from "@xt/xtbase";
const {XtContext,XtAuth} = Context;
const {useTranslation} = Hooks;
import styles from "./index.module.less";
import { useStore } from '@/models';
import { observer } from 'mobx-react-lite';
import {Collapse} from "antd";
const {Panel} = Collapse;
import { CaretRightOutlined } from '@ant-design/icons';

export default observer(({category=0}) => {
  const t = useTranslation();

  const words = ["SimpleEarn","Savings","Staking","CloudMining"];
  const nums = [7, 9, 8, 7];

  if(category < 0 || category > 3)
    return <></>

  const list = [];
  for(let i=0;i<nums[category];++i)
  {
    list.push('finance.faq'+words[category]+(i+1));
  }

  return (
    <div className={styles.financeFaq}>
      <h2 className={styles.financeFaqP}>FAQs</h2>
      <Collapse
        bordered={false}
        expandIcon={({ isActive }) => <CaretRightOutlined rotate={isActive ? 270 : 90} />}
        expandIconPosition="end"
        style={{
          background:"transparent"
        }}
      >
        {list.map((item,index)=>{
          return <Panel header={t(item)} key={index+1} style={{
            background:"transparent",
            border:0,
            borderBottom:"1px solid rgba(0, 0, 0, 0.08)"
          }}>
            <p>{t(item+"Answer")}</p>
          </Panel>
        })}
      </Collapse>
    </div>
  );
});